var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWadeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 244.339,
    height: 42.368,
    viewBox: "0 0 244.339 42.368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 244.339,
    height: 42.368,
    fill: "#03234a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M68.524.5,59.085,28.169l-1.657,6.989h-.721l-1.3-4.9L45.394.5H33.145L23.562,30.259l-.937,4.9H21.9l-1.657-6.989L10.087.5H0L15.492,42.8H27.741l9.727-28.318,1.369-4.612h.721L41,14.479,50.8,42.8H63.048L77.891,4.823,78.612.5Z",
    transform: "translate(0 -0.428)",
    fill: "#03234a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M571.613,0,550.5,42.368h10.52l4.683-9.151h11.6l6.989-7.061h-16l9.944-19.671h.72L588.329,26.3l7.422,16.068h11.1L585.807,0Z",
    transform: "translate(-471.168)",
    fill: "#03234a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12-2",
    "data-name": "Group 12",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M984.788,42.368V10.088H994.3V35.451h22.625q5.547,0,5.62-5.116V11.961a5.414,5.414,0,0,0-1.225-3.567q-1.226-1.476-4.4-1.477H984.5L991.417,0H1017.5q5.836,0,8.971,1.441a8.278,8.278,0,0,1,4.359,4.287,18.022,18.022,0,0,1,1.225,7.1V29.471a18.7,18.7,0,0,1-1.189,7.169,8.113,8.113,0,0,1-4.323,4.287q-3.134,1.442-9.043,1.441Z",
    transform: "translate(-842.624)",
    fill: "#03234a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M1429.318,42.368H1384.5V0h44.818L1422.4,6.917h-28.39v9.944h18.518l-7.133,7.133h-11.385V35.451h28.39Z",
    transform: "translate(-1184.98)",
    fill: "#03234a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWadeIcon);
export default __webpack_public_path__ + "static/media/wadeIcon.3ded24b760f52156e5e8f7dac26a375c.svg";
export { ForwardRef as ReactComponent };